import React from 'react'
import AboutComp from '../Component/AboutComp/AboutComp'
import Card from '../Component/Card/Card'
import Header from '../Component/Header/Header'

function Home() {
  return (
    <>
    <Header/>
  <AboutComp/>
  <Card/>
    </>
	
  )
}

export default Home